<template>
  <div class="p-6 min-w-min h-full flex flex-col bg-white rounded-2xl">
    <!-- title and search bar -->
    <div class="flex flex-row items-center justify-between mb-4">
      <p class="text-3xl font-bold">Manage Category</p>
    </div>
    <!-- body -->
    <div>
      <table class="table-auto w-full font-light">
        <thead class="border-b-2 border-light-gray">
          <tr class="text-left text-gray text-md">
            <th class="py-2 font-normal text-center">Thumbnail</th>
            <th class="py-2 font-normal">Category Name</th>
            <th class="py-2 font-normal">Description</th>
            <th class="py-2 font-normal text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="category in categories" :key="category.id" class="text-lg">
            <td>
              <div class="flex justify-center">
                <img
                  class="rounded-lg rectangle_img w-40 object-cover my-2"
                  :src="category.image"
                  alt=""
                />
              </div>
            </td>
            <td class="px-4 align-top">
              {{ category.name }}
            </td>
            <td class="px-2 w-auto truncate-2-lines align-top text-gray">
              {{ category.description }}
            </td>
            <td>
              <div class="flex justify-center relative">
                <Menu>
                  <MenuButton>
                    <EllipsisVerticalIcon
                      class="w-8 h-8 text-black hover:text-blue cursor-pointer"
                    />
                  </MenuButton>
                  <MenuItems
                    class="
                      p-1
                      space-y-1
                      absolute
                      top-8
                      right-0
                      z-50
                      bg-white
                      border border-light-gray
                      shadow-md
                      rounded-lg
                      w-12/12
                    "
                  >
                    <MenuItem
                      @click="handleUpdate(category)"
                      class="hover:bg-light-blue m-1 rounded-md cursor-pointer"
                    >
                      <div
                        class="flex flex-row items-center px-4 py-2 min-w-min"
                      >
                        <PencilIcon class="text-blue w-5 h-5 mr-4" />
                        <p class="text-blue">Edit</p>
                      </div>
                    </MenuItem>
                  </MenuItems>
                </Menu>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- update side bar -->
  <!-- update page content -->
  <SideBar v-show="showUpdateSideBar" @close-modal="handleUpdateSideBar">
    <div class="w-full h-full flex flex-col content-between">
      <!-- header -->
      <h1 v-if="!updateFlag" class="text-blue text-2xl">Create New Event</h1>
      <h1 v-else class="text-blue text-2xl">Update Content</h1>
      <!-- body -->
      <div class="flex flex-col space-y-2">
        <div>
          <div
            @click="handleFileImport"
            class="group py-4 cursor-pointer relative"
          >
            <p class="text-gray mb-2 font-normal">Image</p>
            <!-- hiddden image file input field that triger when profile image container clicked -->
            <input
              ref="imageFileUploader"
              class="hidden"
              type="file"
              name="profileImage"
              id="profileImage"
              @change="handleFileUpload($event)"
            />
            <div class="flex justify-center">
              <img
                v-if="imageUrl"
                class="w-full rectangle_img object-cover rounded-lg mb-2"
                :src="imageUrl"
                alt=""
              />
              <img
                v-else
                class="w-full rectangle_img object-cover rounded-lg mb-2"
                src="https://www.berchielli.co.uk/wp-content/themes/barberry/images/placeholder.jpg"
                alt=""
              />
            </div>
            <p
              v-if="imageUrl"
              class="
                cursor-pointer
                text-center text-lg
                font-sans
                text-blue
                group-hover:underline
              "
            >
              Change image
            </p>
            <p
              v-else
              class="
                cursor-pointer
                text-center text-lg
                font-sans
                text-blue
                group-hover:underline
              "
            >
              Add image
            </p>
          </div>
          <div
            v-show="imageUrl"
            @click="handleClearImage"
            class="
              flex
              items-center
              justify-center
              p-3
              bg-red
              rounded-full
              absolute
              right-0
              top-16
              cursor-pointer
            "
          >
            <TrashIcon class="text-white h-6 w-6" />
          </div>
        </div>
        <base-text-input
          v-model="name"
          name="name"
          isAutoComplete="off"
          label="Name"
        />
        <base-text-input
          v-model="description"
          name="description"
          isAutoComplete="off"
          label="Description"
        />
      </div>
      <!-- action button -->
      <div
        class="
          flex flex-row
          items-center
          justify-between
          space-x-4
          mt-auto
          mb-4
        "
      >
        <BaseRoundedButton
          @click="handleUpdateSideBar"
          class="bg-dark-gray w-2/6"
        >
          <p>Cancel</p>
        </BaseRoundedButton>
        <BaseRoundedButton @click="handleSaveUpdate" class="w-4/6">
          <p>Save Update</p>
        </BaseRoundedButton>
      </div>
    </div>
  </SideBar>
</template>

<script>
import userService from "../Services/user.service";
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import {
  EllipsisVerticalIcon,
  PencilIcon,
  TrashIcon,
} from "@heroicons/vue/24/outline";
import SideBar from "../components/SideBar.vue";
import BaseTextInput from "../components/BaseTextInput.vue";
import { useToast } from "vue-toastification";
import BaseRoundedButton from "../components/BaseRoundedButton.vue";
export default {
  name: "ManageCategory",
  components: {
    EllipsisVerticalIcon,
    PencilIcon,
    TrashIcon,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    SideBar,
    BaseTextInput,
    BaseRoundedButton,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      showUpdateSideBar: false,
      categories: [],
      imageUrl: "",
      imageFile: "",
      name: "",
      description: "",
      tempId: "",
    };
  },
  methods: {
    getCategories() {
      userService.getCategory().then((response) => {
        this.categories = response.data.data;
      });
    },
    handleUpdateSideBar() {
      this.showUpdateSideBar = !this.showUpdateSideBar;
      this.tempId = "";
      this.imageUrl = "";
      this.name = "";
      this.description = "";
    },
    handleUpdate(value) {
      this.showUpdateSideBar = true;
      this.tempId = value.id;
      this.imageUrl = value.image;
      this.name = value.name;
      this.description = value.description;
    },
    handleFileImport() {
      this.$refs.imageFileUploader.click();
    },
    handleFileUpload(event) {
      this.imageFile = event.target.files[0];
      this.imageUrl = URL.createObjectURL(this.imageFile);
    },
    handleClearImage() {
      this.imageUrl = "";
      this.imageFile = "";
    },
    handleSaveUpdate() {
      this.$Progress.start();
      let formData = new FormData();
      if (!this.imageUrl || this.imageFile) {
        formData.append("image", this.imageFile);
      }
      formData.append("name", this.name);
      formData.append("description", this.description);

      userService
        .storeUpdateCategory(this.tempId, formData)
        .then(() => {
          this.$Progress.finish();
          this.tempId = "";
          this.imageUrl = "";
          this.name = "";
          this.description = "";
          this.getCategories();
          this.showUpdateSideBar = false;
          this.toast.success("Update category successful.");
        })
        .catch((error) => {
          this.$Progress.fail();
          this.toast.error("Error! Cannot update category.");
          console.log(error);
        });
    },
  },
  created() {
    this.$Progress.start();
    this.getCategories();
  },
  mounted() {
    this.$Progress.finish();
  },
};
</script>

<style scoped>
.rectangle_img {
  aspect-ratio: 16/9;
}
.truncate-2-lines {
  max-height: 3.6em;
  /* double the size of line-height */
  line-height: 1.8em;
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: hidden;
}
</style>